import React, { useEffect } from 'react';
import SideBar from '../SideBar';
import { useDispatch, useSelector } from 'react-redux';
import { getPageContent } from '../../../store/actions/general.actions';
import { createMarkup } from '../../../utils/helper';
import NewLoading from '../../../Components/Common/NewLoading';

const PrivacyPolicy = (props) => {

    const dispatch = useDispatch();
    const { pageContent, pageLoading } = useSelector((state) => state.general);

    useEffect(() => {
        dispatch(getPageContent('privacy_policy'));
    }, []);

    useEffect(() => {
        document.title = `Privcay Policy - JackpotCT`;
        const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        `Protecting your privacy is our top priority. Explore our
        comprehensive privacy policy at JackpotCT to
        understand how we collect, use, and safeguard your
        personal information.`
      );
    }

      }, []);

    return (pageLoading ?
        <NewLoading customClass="min-height-loader" />
        : <div className='d-flex w-100 static-wrap'>
            <SideBar history={props.history} />
            <div className='static-right w-100'>
                <h1>{pageContent?.title}</h1>
                <div className='theme-dark-bg'>
                    <p dangerouslySetInnerHTML={createMarkup(pageContent?.content || '')} className="about-para" />
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
